export default {
  getAll: {
    url: '/api/contribute/getAll',
    method: 'get'
  },
  create: {
    url: '/api/contribute/create',
    method: 'post'
  },
  update: {
    url: '/api/contribute/update',
    method: 'put'
  },
  delete: {
    url: '/api/contribute/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/contribute.js